var render = function render(){var _vm=this,_c=_vm._self._c;return _c('block',[_c('CommentComponent',{attrs:{"platform":_vm.playNow.platform || '163',"comment-type":0,"id":_vm.playNow.id,"comments":_vm.comments}}),_c('SendComment',{attrs:{"type":0,"platform":_vm.playNow.platform || '163',"success-cb":_vm.initComments}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }